"use client";
import React, { useEffect, useState } from "react";
import { Control, useWatch } from "react-hook-form";
import { UseFormSetValue } from "react-hook-form";
import { cn } from "@gettactic/helpers/src/css/cn";
import { Input, TextEditor } from "@/ui/index";
import { Label } from "@cmp-src/primitives/label";
import { EditResourceMultipleForm } from "@/features/reserve/components/resources/tabs/GeneralTabMultiple";

type Props = {
  defaultValues: EditResourceMultipleForm;
  control: Control<EditResourceMultipleForm>;
  setValue: UseFormSetValue<EditResourceMultipleForm>;
  name: "name" | "label" | "description";

  label: string;
};

export function EditMultipleTextInput({
  control,
  setValue,
  name,
  label
}: Props) {
  const values = useWatch({ name: "textBulkValues", control });
  const [edit, setEdit] = useState(false);
  useEffect(() => {
    if (edit) {
      setValue(`textBulkValues.${name}`, "#{{number:1}}");
    } else {
      setValue(`textBulkValues.${name}`, "");
    }
  }, [edit]);
  return (
    <div className="mt-4">
      <div>
        <Label className="text-base text-tertiary">
          <span className="font-bold">{label}</span>
          <button
            onClick={(ev) => {
              ev.preventDefault();
              setEdit((x) => !x);
            }}
            className="mx-2 text-sm text-neutral-700 underline"
          >
            {edit ? "Cancel edit" : "Edit in Bulk"}
          </button>
        </Label>

        {name !== "description" ? (
          <Input
            onChange={(ev) => {
              if (!edit) {
                ev.preventDefault();
                return;
              }
              setValue(`textBulkValues.${name}`, ev.currentTarget.value);
            }}
            readOnly={!edit}
            disabled={!edit}
            type="text"
            id={`${name}-label`}
            value={!edit ? "Multiple values" : values[name]}
          />
        ) : edit ? (
          <div className="my-1">
            <TextEditor
              onChange={(str) => {
                if (!edit || !str) {
                  return;
                }
                setValue(`textBulkValues.${name}`, str);
              }}
              value={values[name] ?? ""}
              id={`textBulkValues.${name}-description`}
            />
          </div>
        ) : (
          <div
            className={cn(
              !edit
                ? "my-1 cursor-not-allowed rounded-md bg-neutral-300 px-3 py-2 text-neutral-900 opacity-50"
                : ""
            )}
          >
            Multiple values
          </div>
        )}
      </div>
    </div>
  );
}
